import { render, staticRenderFns } from "./VideoList.vue?vue&type=template&id=779ba933&scoped=true"
import script from "./VideoList.vue?vue&type=script&lang=js"
export * from "./VideoList.vue?vue&type=script&lang=js"
import style0 from "./VideoList.vue?vue&type=style&index=0&id=779ba933&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "779ba933",
  null
  
)

export default component.exports